import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "name",
        label: <FormattedMessage id="driver.name" />,
        type: "string",
        helpText: <FormattedMessage id="driver-form.help-txt-name" />,
        errorMessage: <FormattedMessage id="driver-form.err-msg-name" />,
        validation: {
            pattern: /^[\u0621-\u064A\u0660-\u0669a-zA-Z ]+$/,
            required: true,
        },
    },
    {
        name: "email",
        label: <FormattedMessage id="driver.email" />,
        type: "string",
        helpText: <FormattedMessage id="driver-form.help-txt-email" />,
        errorMessage: <FormattedMessage id="driver-form.err-msg-email" />,
        validation: {
            pattern: /\S+@\S+\.\S+/,
            required: true,
        },
    },
    {
        name: "supplierId",
        label: <FormattedMessage id="driver.supplier" />,
        type: "list",
        helpText: <FormattedMessage id="driver-form.help-txt-supplier" />,
        url: "/suppliers",
        filterValue: "name",
        errorMessage: <FormattedMessage id="driver-form.err-msg-supplier" />,
        validation: {
            required: true,
        },
        include: true,
        entityName: "supplier",
    },
    {
        name: "password",
        label: <FormattedMessage id="driver.password" />,
        type: "password",
        errorMessage: <FormattedMessage id="driver-form.err-msg-password" />,
        validation: {
            required: true,
        },
    },
    {
        name: "passwordConfirmation",
        label: <FormattedMessage id="driver.password-confirmation" />,
        type: "passwordConfirmation",
        errorMessage: <FormattedMessage id="driver-form.err-msg-password-confirmation" />,
    },
    {
        name: "phoneNumber",
        label: <FormattedMessage id="driver.phone-number" />,
        type: "string",
        helpText: <FormattedMessage id="driver-form.help-txt-phone-number" />,
        errorMessage: <FormattedMessage id="driver-form.err-msg-phone-number" />,
        validation: {
            pattern: /^0\d{10}$/,
            required: true,
        },
    },
    {
        name: "photo",
        label: <FormattedMessage id="driver.picture" />,
        type: "file",
        initialPromptText: <FormattedMessage id="driver-form.prompt-txt-picture" />,
        helpText: <FormattedMessage id="driver-form.help-txt-picture" />,
        accept: "image/jpeg,image/gif,image/png",
        validation: {
            pattern: /^0\d{10}$/,
            required: true,
        },
    },
    {
        name: "driverLicense",
        label: <FormattedMessage id="driver.license" />,
        type: "file",
        initialPromptText: <FormattedMessage id="driver-form.prompt-txt-license" />,
        helpText: <FormattedMessage id="driver-form.help-txt-license" />,
        accept: "image/jpeg,image/gif,image/png",
        validation: {
            pattern: /^0\d{10}$/,
            required: true,
        },
    },
];
